export default __webpack_public_path__ + "static/media/f1.bdcb823f.png";